import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AppSettings } from '../appSettings';

import * as moment from 'moment';
import { Subject } from 'rxjs';

import {
  FormGroup,
  FormControl,
  Validators
} from '@angular/forms';
import { AppFormat } from '../appFormat';
import { IOption } from '../interfaces/option';
import { ActivatedRoute } from '@angular/router';
import { OperadorService } from '../services/operador.service';
import { ProductService } from '../services/product.service';
import { IProduct } from '../interfaces/product';
import { CouponService } from '../services/coupon.service';
import { ICoupon } from '../interfaces/coupon';
import { NavigationService } from '../services/navigation-service.service';

@Component({
  selector: 'app-coupon',
  templateUrl: './coupon.component.html',
  styleUrls: ['./coupon.component.scss'],
  host: { 'class': 'wrapper-coupon' },
  encapsulation: ViewEncapsulation.None
})
export class CouponComponent implements OnInit {

  public couponFrm: FormGroup
  public codigo: FormControl

  public tipo_desconto: FormControl
  public desconto: FormControl
  public tipo_atribuicao: FormControl
  public tipo_requisito: FormControl
  public requisito: FormControl
  public tipo_limite_distribuidos: FormControl
  public limite_distribuidos: FormControl
  public tipo_limite_cliente: FormControl
  public limite_cliente: FormControl
  public dt_inicial: FormControl
  public hora_inicial: FormControl

  public flag_final: FormControl
  public dt_expiracao: FormControl

  public hora_expiracao: FormControl

  public search: FormControl

  public produtos: IProduct[]

  public productChange: boolean = false

  public tipo_atribuicao_list: IOption[] = []
  public tipo_desconto_list: IOption[] = []
  public tipo_requisito_list: IOption[] = []
  public tipo_limite_distribuidos_list: IOption[] = []
  public tipo_limite_cliente_list: IOption[] = []

  public minDate = new Date()
  public startDate = new Date()

  public showModal: boolean = false
  public openModal: boolean = false
  public changeDetail: boolean = false

  private operador;

  public searchTerm$ = new Subject<string>()
  public page: number = 1

  private query
  public strSearch = ''

  public products: IProduct[]
  public produtosSelected: IProduct[]
  public loadingProducts: boolean = false

  public loading: boolean = false

  public loadingCheck: boolean = false
  public errorCode: boolean = false
  public timeCheckOut = null

  public coupon: ICoupon = null;

  constructor(private _operadorService: OperadorService, private _productService: ProductService, private _couponService: CouponService, private _route: ActivatedRoute, private navigation: NavigationService) {
    this.operador = _operadorService.getOperador()

    this.query = { page: this.page }
    this.produtos = []

    this._productService.searchProduct(this.searchTerm$, this.query).subscribe(res => {
      this.products = this.checkListProducts(this.page > 1 ? this.products.concat(res.data) : res.data)

      this.loadingProducts = false

      console.log(this.query);
      this.page = this.page + 1
    })
  }

  ngOnInit(): void {
    this.createFormControls()
    this.createForm()

    this.changeDetail = false
    this.productChange = false

    this.tipo_desconto_list.push({text: 'Percentual', value: 'P'})
    this.tipo_desconto_list.push({text: 'Valor Fixo', value: 'F'})

    this.tipo_atribuicao_list.push({text: 'Pedido inteiro', value: 'I'})
    this.tipo_atribuicao_list.push({text: 'Produtos específicos', value: 'P'})
    this.tipo_atribuicao_list.push({text: 'Frete do pedido', value: 'F'})

    this.tipo_requisito_list.push({text: 'Valor mínimo da compra', value: 'V'})
    this.tipo_requisito_list.push({text: 'Quantia mínima de itens', value: 'Q'})
    this.tipo_requisito_list.push({text: 'Primeira compra do cliente', value: 'P'})

    this.tipo_limite_distribuidos_list.push({text: 'Ilimitado', value: 'I'})
    this.tipo_limite_distribuidos_list.push({text: 'Limitado', value: 'L'})

    this.tipo_limite_cliente_list.push({text: 'Ilimitado', value: 'I'})
    this.tipo_limite_cliente_list.push({text: 'Limitado', value: 'L'})

    this.produtos = []

    this.loading = true
    this._route.params.subscribe(data => {
      //console.log(data['codbarra'])
      if (data['id'] !== undefined) {
        this.getCouponFromId(data['id'])
      } else {
        this.loading = false
      }
    })
  }

  createFormControls() {
    this.codigo = new FormControl('', [
      Validators.required,
    ])

    this.tipo_desconto = new FormControl('P')
    this.desconto = new FormControl(0)
    this.tipo_atribuicao = new FormControl('I')
    this.tipo_requisito = new FormControl(null)
    this.requisito = new FormControl(0)
    this.tipo_limite_distribuidos = new FormControl('I')
    this.limite_distribuidos = new FormControl('')
    this.tipo_limite_cliente = new FormControl('L')
    this.limite_cliente = new FormControl(1)
    this.dt_inicial = new FormControl('')
    this.flag_final = new FormControl('F')
    this.dt_expiracao = new FormControl('')

    this.hora_inicial = new FormControl(null)
    this.hora_expiracao = new FormControl(null)
  }

  createForm() {
    this.couponFrm = new FormGroup({
      codigo: this.codigo,
      tipo_desconto: this.tipo_desconto,
      desconto: this.desconto,
      tipo_atribuicao: this.tipo_atribuicao,
      tipo_requisito: this.tipo_requisito,
      requisito: this.requisito,
      tipo_limite_distribuidos: this.tipo_limite_distribuidos,
      limite_distribuidos: this.limite_distribuidos,
      tipo_limite_cliente: this.tipo_limite_cliente,
      limite_cliente: this.limite_cliente,
      dt_inicial: this.dt_inicial,
      flag_final: this.flag_final,
      dt_expiracao: this.dt_expiracao,
      hora_inicial: this.hora_inicial,
      hora_expiracao: this.hora_expiracao
    })
  }

  onBack() {
    this.navigation.back()
  }

  getCouponFromId(id) {
    this._couponService.show(id).subscribe(res => {
      if (res.idcupom) {

        this.productChange = false

        this.coupon = res

        this.codigo.setValue(res.codigo)
        this.tipo_desconto.setValue(res.tipo_desconto)
        this.desconto.setValue(res.desconto)
        this.tipo_atribuicao.setValue(res.tipo_atribuicao)
        this.tipo_requisito.setValue(res.tipo_requisito)
        this.requisito.setValue(res.requisito)
        this.tipo_limite_distribuidos.setValue(res.tipo_limite_distribuidos)
        this.limite_distribuidos.setValue(res.limite_distribuidos)
        this.tipo_limite_cliente.setValue(res.tipo_limite_cliente)
        this.limite_cliente.setValue(res.limite_cliente)

        this.flag_final.setValue(res.flag_final)

        this.produtos = res.produtos

        if (res.dt_inicial && res.dt_inicial != null) {
          let dtinicial = res.dt_inicial.split(' ')
          this.dt_inicial.setValue(AppFormat.dateYMDUTCMoment(dtinicial[0]))
          if (dtinicial.length > 1) {
            let horainicial = dtinicial[1].split(':')
            this.hora_inicial.setValue(horainicial[0]+':'+horainicial[1])
          }
        }

        if (res.flag_final == 'D' && res.dt_expiracao && res.dt_expiracao != null) {
          let dtexpiracao = res.dt_expiracao.split(' ')
          this.dt_expiracao.setValue(AppFormat.dateYMDUTCMoment(dtexpiracao[0]))
          if (dtexpiracao.length > 1) {
            let horaexpiracao = dtexpiracao[1].split(':')
            this.hora_expiracao.setValue(horaexpiracao[0]+':'+horaexpiracao[1])
          }
        }
      }
      this.loading = false
    })
  }

  requisitoCupom() {
    // ?  : (tipo_requisito.value == 'P' ?  : )
    let text = ''

    if (this.tipo_requisito.value == 'V') {
      text = 'Compra mínima R$' + this.requisito.value
    } else if (this.tipo_requisito.value == 'P') {
      text = 'Primeira compra do cliente'
    } else {
      text = this.requisito.value + (this.requisito.value > 1 ? ' itens' : ' item' ) + ' mínimo na compra'
    }

    return text
  }

  onChangeDetail() {
    this.changeDetail = true
  }

  resetPageSearch() {
    this.page = 1
    this.query = { page: this.page }
    this.loadingProducts = true
  }

  onChangeCodigo() {
    if (this.timeCheckOut) clearTimeout(this.timeCheckOut)

    this.errorCode = true
    this.loadingCheck = true

    this.codigo.setValue(AppFormat.gSlug(this.codigo.value))

    this.timeCheckOut = setTimeout(()=>{
      this.checkCouponCode()
    }, 300)
  }

  checkCouponCode() {
    this._couponService.search({ 'codigo': this.codigo.value }).subscribe(res => {
      if (res.coupons && res.coupons.length > 0 && res.coupons[0].codigo == this.codigo.value && (this.coupon == null || this.coupon.idcupom != res.coupons[0].idcupom)){
        this.errorCode = true
      } else {
        this.errorCode = false
      }
      this.loadingCheck = false

      this.onChangeDetail()
    })
  }

  public selectProduct(product: IProduct) {
    product['selected'] = !product['selected']
    if (product['selected']) {
      this.produtosSelected.push(product)
    } else {
      let j = null
      for(let i in this.produtosSelected) {
        if (this.produtosSelected[i].idproduto_geral == product.idproduto_geral) {
          j = i
          break
        }
      }
      if (j != null){
        this.produtosSelected.splice(j, 1)
      } else {
        for(let i in this.produtos) {
          if (this.produtos[i].idproduto_geral == product.idproduto_geral) {
            j = i
            break
          }
        }
        if (j != null){
          this.produtos.splice(j, 1)
        }
      }

    }
    this.productChange = true
    this.onChangeDetail()
  }

  private checkListProducts(list) {
    for(let i in list) {
      list[i]['selected'] = false
      for(let j in this.produtos) {
        if (this.produtos[j]['idproduto_geral'] == list[i]['idproduto_geral']) {
          list[i]['selected'] = true
        }
      }

      for(let j in this.produtosSelected) {
        if (this.produtosSelected[j]['idproduto_geral'] == list[i]['idproduto_geral']) {
          list[i]['selected'] = true
        }
      }
    }

    return list
  }

  private findProducts() {
    this.query['page'] = this.page
    this.query['search'] = this.strSearch


    this.loadingProducts = true

    this._productService.search(this.query).subscribe(res => {
      if (res['success']) {

        this.products = this.checkListProducts(this.page > 1 ? this.products.concat(res.data) : res.data)

        this.page = this.page + 1

        this.loadingProducts = false
      } else {
        //error
      }
    },error => {

    })
  }

  generateCode() {
    let cod = 'PROM'
    if (this.operador && this.operador.estabelecimento && this.operador.estabelecimento.nome){
      let nome =  this.operador.estabelecimento.nome
      cod += nome.replace(/ /g, "").substring(0, 4).toUpperCase()
    }
    cod += moment().unix().toString().substring(7, 10).toUpperCase() + AppFormat.makeid(2)
    this.codigo.setValue(cod);
    this.onChangeCodigo()
  }

  openModalProducts() {
    this.products = []
    this.produtosSelected = []
    this.showModal = true
    this.strSearch = ''
    setTimeout(() => {
      this.openModal = true
    }, 200)
  }

  putProducts() {
    for(let i in this.produtosSelected) {
      this.produtos.push(this.produtosSelected[i])
    }
    this.produtosSelected = []
    this.closeModalProducts()
    this.onChangeDetail()
  }

  closeModalProducts() {
    this.openModal = false
    setTimeout(() => {
      this.showModal = false
    }, 200)
  }

  configRequisito() {
    if (this.tipo_requisito.value == 'Q') {
      return { precision: 0, allowNegative: false }
    } else {
      return { precision: 2, allowNegative: false }
    }
  }

  onScroll() {
    if (!this.loading) {
      this.findProducts()
    }
  }

  couponValid() {
    let has = true

    let msg = []

    if ((this.codigo.invalid && (this.codigo.dirty || this.codigo.touched)) || this.codigo.value == '' || this.codigo.value == undefined  || this.codigo.value == null) {
      msg.push('Você precisa preencher o código do cupom!');
      has = false
    }

    if ((this.dt_inicial.invalid && (this.dt_inicial.dirty || this.dt_inicial.touched)) || this.dt_inicial.value == '' || this.dt_inicial.value == undefined  || this.dt_inicial.value == null) {
      msg.push('Você precisa preencher a data de início do cupom!');
      has = false
    }

    if (this.errorCode) {
      msg.push('O código do cupom já existe!');
      has = false
    }

    if (msg.length > 0) {
      Swal.fire("Ops!", msg.join("<br>"), "error");
    }

    return has
  }

  onCancelCoupon() {
    Swal.fire({
      title: 'Você deseja cancelar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!'
    }).then((result) => {
      if (result.value) {
        this.loading = true
        this.getCouponFromId(this.coupon.idcupom)
      }
    })
  }

  saveError() {
    Swal.fire("Ops!", "Ocorreu um erro ao tentar salvar.", "error")
  }

  saveComplete() {
    Swal.fire("Salvo!", "O cupom foi salvo", "success")
  }

  saving() {
    Swal.fire({
      title: "Salvando...",
      icon: "info",
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: false
    });
  }

  onSubmit() {
    if (this.couponValid()) {

      let dtinicial, dtexpiracao = ''
      if (this.dt_inicial.value != null && typeof(this.dt_inicial.value) === 'object') {
        dtinicial = this.dt_inicial.value.format('YYYY-MM-DD');
      } else {
        dtinicial = this.dt_inicial.value
      }
      if (this.hora_inicial.value != '' && this.hora_inicial.value != null) {
        dtinicial += ' '+this.hora_inicial.value+':00'
      } else {
        dtinicial += ' 00:00:00';
      }

      if (this.dt_expiracao.value != null && typeof(this.dt_expiracao.value) === 'object') {
        dtexpiracao = this.dt_expiracao.value.format('YYYY-MM-DD');
      } else {
        dtexpiracao = this.dt_expiracao.value
      }
      if (this.hora_expiracao.value != '' && this.hora_expiracao.value != null) {
        dtexpiracao += ' '+this.hora_expiracao.value+':00'
      } else {
        dtexpiracao += ' 00:00:00';
      }

      let data = {
        codigo: this.codigo.value,
        tipo_desconto: this.tipo_desconto.value,
        desconto: this.desconto.value,
        tipo_atribuicao: this.tipo_atribuicao.value,
        tipo_requisito: this.tipo_requisito.value,
        requisito: this.requisito.value,
        tipo_limite_distribuidos: this.tipo_limite_distribuidos.value,
        limite_distribuidos: this.limite_distribuidos.value,
        tipo_limite_cliente: this.tipo_limite_cliente.value,
        limite_cliente: this.limite_cliente.value,
        flag_final: this.flag_final.value,
        dt_inicial: dtinicial,
        dt_expiracao: dtexpiracao
      }

      data['produtos'] = []

      for(let i in this.produtos) {
        data['produtos'].push(this.produtos[i].idproduto_geral)
      }

      if (this.productChange) {
        data['alteracao_produtos'] = true
      }

      this.saving()

      if (this.coupon != null && this.coupon.idcupom > 0) {
        this.patchCoupon(this.coupon.idcupom, data)
      } else {
        this.storeCoupon(data)
      }
    }

    return null
  }

  storeCoupon(data) {
    this._couponService.store(data).subscribe(res => {
      if (res['success']) {
        this.coupon = res['coupon']
        this.saveComplete()
      } else {
        this.saveError()
      }
    })
  }

  patchCoupon(id, data) {
    this._couponService.patch(id, data).subscribe(res => {
      if (res['success']) {
        this.coupon = res['coupon']
        this.saveComplete()
      } else {
        this.saveError()
      }
    })
  }

}
